export default __webpack_public_path__ + "static/char-s-49-ja-a20bcb999343abd6e0228bc19b4d9af9.png";